import { KnownDeviceType } from "../../index.js";
import { toLoraEui } from "../../utils/shortCodes/EuiShortCodeMapper.js";
import { NodeIdString, UuidString, VendorOpaqueIdString } from "../../zod-decorator/decorators/helper-types.js";
import type { DeviceIdentifierScheme, IdentifierSchemeConfiguration } from "./types.js";

const lowercase = (nodeId: string) => nodeId.toLowerCase();

/** An ID in the format printed on each device type's label, to show the user what to look for. */
// TODO: ePlantTreeTag example is not correct, it should be the tag ID and execute QR scan logic as well - coming soon to a PR near you
const EXAMPLE_DEVICE_IDS: Partial<Record<KnownDeviceType, string>> = {
    gen4_block: "eui-fcc23d000042ee25",
    ePlantTreeTag: "eui-8c1f649f000020d9",
};

/** An example ID for the device type, or `undefined` when there is none to show. */
export const exampleManualDeviceId = (deviceType: KnownDeviceType): string | undefined =>
    EXAMPLE_DEVICE_IDS[deviceType];

/**
 * Per-scheme rules for validating and normalizing a device's `node_id`. Device types pick a scheme via
 * `DeviceTypeConfigurations[].identifierScheme`; this table is the shared behaviour for that scheme.
 */
export const IdentifierSchemeConfigurations: Record<DeviceIdentifierScheme, IdentifierSchemeConfiguration> = {
    // Hex is case-insensitive, but the stored form is lowercase so exact-match lookups and the
    // AssetIdentity unique index see one value per device.
    loraEui: {
        storedFormat: NodeIdString,
        normalizeInput: toLoraEui,
    },
    // UUIDs are case-insensitive (RFC 9562), but the stored form is lowercase
    uuid: {
        storedFormat: UuidString,
        normalizeInput: lowercase,
    },
    vendorOpaque: {
        storedFormat: VendorOpaqueIdString,
        normalizeInput: (nodeId) => nodeId,
    },
};
